import { createPinia } from 'pinia';
import { Globals } from '@/store/plugins/Globals';
import { piniaHooksPlugin } from '@/store/plugins/piniaHooksPlugin';

export const pinia = createPinia();
pinia.use(Globals);
pinia.use(piniaHooksPlugin);
